module.exports = __webpack_public_path__ + "m5.png";